import {
    COMMAND_PRIORITY_LOW,
    createCommand, LexicalCommand,
    LexicalNode
} from "lexical"
import {useLexicalComposerContext} from "@lexical/react/LexicalComposerContext"
import {BadgeNode} from "./node/badge-node"
import {mergeRegister} from "@lexical/utils"
import {useEffect} from "react"
import toggleBadge from "./action/toggle-badge"

export enum BadgeType {
    LIGHT_BLUE  = 'badge-light-blue',
    DARK_BLUE   = 'badge-dark-blue',
    GREEN       = 'badge-green',
    YELLOW      = 'badge-yellow',
    ORANGE      = 'badge-orange',
    RED         = 'badge-red',
    MAGENTA     = 'badge-magenta',
    PURPLE      = 'badge-purple',
    BROWN       = 'badge-brown',
    GRAY        = 'badge-gray',
}

export const INSERT_BADGE_COMMAND: LexicalCommand<BadgeType | null> = createCommand('insertBadge')

const debug = false
// const debug = "BadgePlugin"

export function BadgePlugin(): null {
    const [editor] = useLexicalComposerContext()

    useEffect(() => {
        // check if node is added to config and show warning if not
        if (!editor.hasNodes([BadgeNode])) {
            throw new Error('FontColorPlugin: FontColorNode is not registered on editor')
        }
        return mergeRegister(
            editor.registerCommand(
                INSERT_BADGE_COMMAND,
                (badgeType:BadgeType | null) => {
                    toggleBadge(badgeType)
                    return true
                },
                COMMAND_PRIORITY_LOW,
            )
        )
    }, [editor])

    return null
}

// lexical convention function
export function $createBadgeNode(type: BadgeType): BadgeNode {
    return new BadgeNode(type)
}

// lexical convention function
export function $isBadgeNode(
    node: LexicalNode | null | undefined,
): node is BadgeNode {
    return node instanceof BadgeNode;
}